import { createContext, ReactNode, useContext } from 'react';
import { observer } from 'mobx-react-lite';

import { apiClient } from './api-client';

const ApiClientContext = createContext(apiClient);
const Provider = ApiClientContext.Provider;
export const ApiClientProvider = observer(
  ({ children }: { children: ReactNode }) => (
    <Provider value={apiClient}>{children}</Provider>
  )
);
export const useApiClient = () => {
  const apiClient = useContext(ApiClientContext);

  if (apiClient === undefined) {
    throw new Error('useApiClient must be within ApiClientProvider');
  }

  return apiClient;
};
